import type { AssignableAccount } from '@shared/types/account';

/// 事務所詳細ページ固有の表示ロジック。
///
/// FirmDetailPage は表示専念にするため、純粋な変換関数をここに切り出す。
/// DOM / store / Svelte に依存しない純粋関数のみ配置する。
/// `assigneeDisplayName` は読み込み状態を考慮し、「読み込み中」と「解決不能」を
/// 区別することで、担当者ありの顧客を「(未割当)」と取り違えないようにする。

/// 担当者 ID を表示名に変換する。
///
/// - `accountId` が nullish → 「(未割当)」
/// - `loaded` が false (ロード未完了) → 「読み込み中…」
/// - candidates に見つかった → 表示名
/// - 見つからなかった (候補外 / 無効化済み等) → 「不明な担当者」
export function assigneeDisplayName(
  accountId: string | null | undefined,
  candidates: AssignableAccount[],
  loaded: boolean,
): string {
  if (!accountId) return '(未割当)';
  if (!loaded) return '読み込み中…';
  const found = candidates.find((a) => a.id === accountId);
  if (found) return found.display_name;
  return '不明な担当者';
}

/// ISO 文字列の先頭 10 文字 (yyyy-mm-dd) を取り出す。nullish は '-'。
///
/// src/lib/utils/labels.ts:formatDate と同じ変換規則を踏襲する。
export function formatHeaderDate(iso: string | null | undefined): string {
  if (!iso) return '-';
  return iso.slice(0, 10);
}

/// 文字列を trim し、空なら「理由未設定」を返す。
export function reasonOrUnset(value: string | null | undefined): string {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : '理由未設定';
}
